class AccordionContent extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const accordionHeaders = this.querySelectorAll('.accordion-header')
    accordionHeaders.forEach((header) => {
      const accordionItem = header.parentElement
      let getHeight = accordionItem.querySelector('.accordion-item__content').scrollHeight
      accordionItem.style.setProperty('--max-height', getHeight + 'px')
      header.addEventListener('click', () => {
        const accordionItem = header.parentElement
        accordionItem.classList.toggle('active')
      })
    })
  }
}

customElements.define('accordion-content', AccordionContent)
